import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=1f5e761c&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"
import style0 from "./Item.vue?vue&type=style&index=0&id=1f5e761c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5e761c')) {
      api.createRecord('1f5e761c', component.options)
    } else {
      api.reload('1f5e761c', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=1f5e761c&", function () {
      api.rerender('1f5e761c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PoService/Item.vue"
export default component.exports